const VIDEO_TYPE_YOUTUBE = 'Youtube';
const VIDEO_TYPE_VIMEO = 'Vimeo';
const VIDEO_TYPE_HTML5 = 'Html5';

export default {
    VIDEO_TYPE_YOUTUBE,
    VIDEO_TYPE_VIMEO,
    VIDEO_TYPE_HTML5
};
